<template>
<div class="chapter">
<div class="inner_page">
<p class="h2" id="p27"><span><a href="#/Contents#rp27">CRUNCHY VEGETABLE SOUP</a></span></p>
<p class="imagel"><span><img alt="" height="5" src="images/line-3.jpg" width="532"/></span></p>
<p class="imagela"><span><img alt="" height="22" src="images/45.jpg" width="22"/></span></p>
<p class="normal"><span><i>Any combination of vegetables may be used for this soup—broccoli, cauliflower, cucumbers, radishes—just as long as they’re crunchy!</i></span></p>
<p class="make"><span>4 first-course servings</span></p>
<p class="hang"><span>1½ cups cut asparagus (1-inch)</span></p>
<p class="hang"><span>¼ cup each: coarsely chopped carrot, celery, onion, mushrooms</span></p>
<p class="hang"><span>1 cup each: reduced-sodium fat-free chicken broth, fat-free plain yogurt</span></p>
<p class="hang"><span>Pinch dried tarragon leaves</span></p>
<p class="hang"><span>Salt and pepper, to taste</span></p>
<p class="hang"><span>Chopped parsley, as garnish</span></p>
<p class="normalt"><span><a id="page_22"></a><b>1.</b> Process vegetables and chicken broth in food processor or blender until finely chopped; pour into medium saucepan and heat to boiling. Reduce heat and simmer, covered, until vegetables are crisp-tender, 5 to 8 minutes. Stir in yogurt and tarragon; season to taste with salt and pepper. Garnish each bowl of soup with parsley.</span></p>
<p class="per"><span>Per Serving:</span></p>
<p class="per1"><span>Calories: 63</span></p>
<p class="per1"><span>% calories from fat: 4</span></p>
<p class="per1"><span>Protein (g): 6.3</span></p>
<p class="per1"><span>Carbohydrate (g): 9.3</span></p>
<p class="per1"><span>Fat (g): 0.3</span></p>
<p class="per1"><span>Saturated fat (g): 0.1</span></p>
<p class="per1"><span>Cholesterol (mg): 1</span></p>
<p class="per1"><span>Sodium (mg): 102</span></p>
<p class="per"><span>Exchanges:</span></p>
<p class="per1"><span>Milk: 0.0</span></p>
<p class="per1"><span>Vegetable: 2.0</span></p>
<p class="per1"><span>Fruit: 0.0</span></p>
<p class="per1"><span>Bread: 0.0</span></p>
<p class="per1"><span>Meat: 0.0</span></p>
<p class="per1"><span>Fat: 0.0</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter029.vue?70cf8bfc